import { IIconProps } from "../types"

export default function IconLL3(props: IIconProps) {
  const width = props.size || props.width || 69
  const height = props.size || props.height || 102
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 69 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.0748 0.800516C39.7348 0.210516 37.9148 0.350516 35.8248 1.32052C33.7448 2.30052 31.4048 4.12052 27.4948 6.69052C23.5848 9.26052 18.1248 12.5905 14.2748 15.1905C10.4348 17.7905 8.2248 19.6805 6.1448 21.8305C4.0548 23.9805 2.1048 26.3905 1.1248 28.8305C0.154796 31.2705 0.154796 33.7405 1.6148 42.3005C3.0848 50.8705 6.0148 65.5205 8.3248 75.1505C10.6348 84.7905 12.3248 89.4105 14.1848 92.9205C16.0348 96.4405 18.0548 98.8505 21.3148 100.181C24.5648 101.521 29.0548 101.781 33.2248 101.321C37.3948 100.871 41.2348 99.6905 44.3848 96.8905C47.5448 94.1005 50.0248 89.6705 52.6848 83.6105C55.3548 77.5605 58.2248 69.8805 60.6048 62.7505C62.9748 55.6205 64.8648 49.0405 66.1048 43.3505C67.3348 37.6505 67.9248 32.8305 68.0548 28.9605C68.1848 25.0805 67.8548 22.1605 66.7848 19.6205C65.7148 17.0805 63.8848 14.9305 60.9948 12.3905C58.0948 9.85052 54.1248 6.92052 50.7048 4.80052C47.2848 2.69052 44.4248 1.39052 42.0748 0.800516Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
